/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Whisper event states for user notifications about persisted settings.
 * Used to inform users when their language preferences couldn't be applied.
 *
 * Implemented as const object + type for type-safe string literal union.
 */
export const WhisperEventState = {
  /**
   * Audio language preference could not be persisted.
   */
  AUDIO_LANGUAGE_NOT_PERSISTED: "AUDIO_LANGUAGE_NOT_PERSISTED",

  /**
   * Closed caption language preference could not be persisted.
   */
  CC_LANGUAGE_NOT_PERSISTED: "CC_LANGUAGE_NOT_PERSISTED"
} as const;

/**
 * Type representing valid WhisperEventState values.
 */
export type WhisperEventState =
  (typeof WhisperEventState)[keyof typeof WhisperEventState];
